<template>
    <button class="popup" :class="{ 'is-active':isActive, 'with-icon':!!iconStyle }" @click="handleButtonClick" :title="title" :style="iconStyle">
        {{ name }}
        <slot />
    </button>
</template>


<script>

export default {
    name: 'popup-button',
    data() {
        return {
            isActive: false
        }
    },
    props: {
        name: String,
        iconStyle: Object,
        title: String
    },
    watch: {
        isActive() {
            if (this.isActive) {
                document.body.addEventListener('click', this.handleClickAnywhere)
            }
        }
    },
    methods: {
        handleButtonClick() {
            this.isActive = !this.isActive
        },
        handleClickAnywhere() {
            this.isActive = false
            document.body.removeEventListener('click', this.handleClickAnywhere)
        }
    }
}

</script>


<style lang="scss">

    .fixed-menu button.popup {
        width: inherit;
        padding: 2px 14px;

        @include mobile {
            display: none;
        }

        ul.popup-menu {
            display: none;
            position: absolute;
            top: 32px;
            left: 0;
            min-width: 100%;
            margin: 0;
            padding: 0;
            list-style-type: none;
            box-shadow: 2px 2px 4px rgba(0,0,0,0.4);
            background-color: rgba(255, 255, 255, 0.9);
            font-size: 14px;
            white-space: nowrap;

            li {
                margin: 0;
                padding: 0;
                list-style-type: none;
                text-align: left;

                a {
                    display: block;
                    min-width: calc(100% - 20px);
                    padding: 4px 10px;
                    color: $body-text-color;

                    &:hover {
                        background-color: $body-background-color;
                        text-decoration: none;
                    }
                }
            }
        }

        &.with-icon {
            padding: inherit;
            margin-right: 14px;
        }

        &.with-icon::after {
            padding-left: 30px;
        }

        &.is-active {

            background-color: rgba(255, 255, 255, 1.0);
            color: $body-text-color;

            ul.popup-menu {
                display: block;
            }
        }

        &::after {
            display: inline-block;
            position: relative;
            margin: 0 0 0 2px;
            top: 2px;
            font-family: 'Material Icons';
            font-size: 14px;
            content: 'arrow_drop_down';
        }
    }

</style>
